import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import {AudioOutlined} from "@ant-design/icons";

export default function NewSessionWithPatientButton({ onClick }) {
  const { t } = useTranslation();

  return (
    <Button
      type="primary"
      icon={<AudioOutlined />}
      data-testid='new-session-with-patient-button'
      onClick={onClick}
    >
      {t('session_recorder.fields.start')}
    </Button>
  );
}